import { css } from '@microsoft/fast-element';
import { getToken } from '../../design-tokens';
import { elevationRule } from '../../styles/elevation';

export const paletteStyles = css`
    .swatch {
        --elevation: ${getToken('space-low-elevation')};
        display: inline-block;
        width: calc(${getToken('space-design-unit')} * 3px);
        height: calc(${getToken('space-design-unit')} * 3px);
        ${elevationRule}
    }

    .target {
        font-weight: bold;
    }
`;
